import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const clickHandlerRegistrarSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'clickHandlerRegistrar'

export const config = { site: clickHandlerRegistrarSiteConfig, reactNativeSite: clickHandlerRegistrarSiteConfig, name }
